'use strict';

$ = jQuery;

/*
* Evento de clique no CTA do Patrocinador do Catálogo
*/
$('.jc-sponsor-cta').on('click', function () {
  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Catálogo 0km',
    'eventAction': 'Clique - Patrocinador - CTA',
    'eventLabel': $(this).attr('alt')
  });

  gtag('event', 'Catálogo 0km', {
    'eventAction': 'Clique - Patrocinador - CTA',
    'eventLabel': $(this).attr('alt')
  });
});